import React from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { Button, makeStyles, CircularProgress } from '@material-ui/core'

import { SUBMIT, CANCEL, SECONDARY, VOTE } from 'app/constants/button'

const useStyles = makeStyles((theme) => ({
  root: {
    '&.MuiButton-root.Mui-disabled': {
      color: '#FFF',
      backgroundColor: `${theme.colors['grey-100']} !important`,
    },
  },
  submit: {
    backgroundColor: theme.colors['primary'],
    color: '#FFF',
    textTransform: 'none',
    padding: '0.75rem 1.25rem',
    '&:hover': {
      backgroundColor: theme.colors['primary-500'],
    },
    '&:action': {
      backgroundColor: theme.colors['primary'],
    },
  },
  cancel: {
    backgroundColor: theme.colors['red-500'],
    color: '#FFF',
    textTransform: 'none',
    padding: '0.75rem 1.25rem',
    '&:hover': {
      backgroundColor: theme.colors['red-600'],
    },
    '&:action': {
      backgroundColor: theme.colors['red-500'],
    },
  },
  secondary: {
    backgroundColor: theme.colors.secondary,
    color: theme.colors['primary-lighter'],
    textTransform: 'none',
    padding: '0.75rem 1.25rem',
    '&:hover': {
      backgroundColor: theme.colors['secondary-200'],
    },
    '&:action': {
      backgroundColor: theme.colors['secondary-200'],
    },
  },
  light: {
    backgroundColor: theme.colors['primary-lighter'],
    border: `1px solid ${theme.colors.secondary}`,
    color: theme.colors.secondary,
    textTransform: 'none',
    padding: '0.75rem 1.25rem',
    '&:hover': {
      backgroundColor: theme.colors['grey-light'],
    },
    '&:action': {
      backgroundColor: theme.colors['grey-light'],
    },
  },
  vote: {
    backgroundColor: '#0073B1',
    color: theme.colors['primary-lighter'],
    textTransform: 'none',
    padding: '0.75rem 1.25rem',
    '&:hover': {
      backgroundColor: '#0073B1',
    },
    '&:action': {
      backgroundColor: '#0073B1',
    },
    '&.MuiButton-root.Mui-disabled': {
      opacity: '0.5 !important',
      backgroundColor: '#0073B1 !important',
    },
  },
  w150: {
    width: '150px',
  },
}))

const ContainedButton = ({
  id,
  color,
  children,
  className,
  isLoading = false,
  disabled = false,
  ...rest
}) => {
  const classes = useStyles()

  const handleType = (color) => {
    switch (color) {
      case SUBMIT:
        return classes.submit
      case CANCEL:
        return classes.cancel
      case SECONDARY:
        return classes.secondary
      case VOTE:
        return classes.vote
      default:
        return
    }
  }

  return (
    <Button
      className={clsx(classes.root, handleType(color), className, disabled)}
      disabled={disabled}
      data-testid={id}
      {...rest}
    >
      {isLoading ? (
        <div
          className={clsx(
            'flex justify-center',
            isLoading ? classes.w150 : 'w-fit',
          )}
        >
          <CircularProgress size={24} style={{ color: 'white' }} />
        </div>
      ) : (
        <span>{children}</span>
      )}
    </Button>
  )
}

ContainedButton.propTypes = {
  id: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  isLoading: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  color: PropTypes.string.isRequired,
  children: PropTypes.node,
}

export default ContainedButton
